/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";

import { ColoredH2 } from "../../components/ColoredHeader";
import { CenteredHero } from "../../components/HeroImage";

import { colors } from "../../theme";

import hero from "./assets/laptop.png";

const h2Style = css`
    margin: 24px auto;
    text-align: center;
`;

const paragraphStyle = css`
    margin: 0 auto;
`;

const EvaluatingApplication = () => (
    <>
        <CenteredHero
            width={200}
            marginTop={40}
            src={hero}
            alt="Illustration of a laptop"
        />
        <ColoredH2 additionalStyles={h2Style} color={colors.secondary8}>
            Evaluating your application
        </ColoredH2>
        <p css={paragraphStyle}>
            Sit tight &ndash; it might take a little time
        </p>
    </>
);

export default EvaluatingApplication;
